import styled from 'styled-components';

export const Container = styled.div`
  min-height: 300px;
  & .MuiBox-root {
    padding: 0;
    padding-top: 20px;
  }
`;
